// fr.gestionpial.user.services.RegisterServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';
import { LoginResponse } from '../entities/LoginResponse';
import { EmailAvailability } from '../entities/EmailAvailability';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  private irpc = inject(IRPC);

  confirmEmail = (token: string): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'RegisterService.confirmEmail';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(token, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  emailAvailable = (email: string): RpcRequestBuilder<EmailAvailability> => {
    const req = new JSONRpcRequest();
    req.method = 'RegisterService.emailAvailable';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(email, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'fr.gestionpial.user.dto.EmailAvailability');
  };

  register = (firstName: string, lastName: string, email: string, password: string): RpcRequestBuilder<LoginResponse> => {
    const req = new JSONRpcRequest();
    req.method = 'RegisterService.register';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(firstName, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(lastName, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(email, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(password, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.services.dto.LoginResponse');
  };

}
